import { render, staticRenderFns } from "./Modal3d.vue?vue&type=template&id=06f406e0&scoped=true&"
import script from "./Modal3d.vue?vue&type=script&lang=js&"
export * from "./Modal3d.vue?vue&type=script&lang=js&"
import style0 from "./Modal3d.vue?vue&type=style&index=0&id=06f406e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f406e0",
  null
  
)

export default component.exports